import ActionTypes from "../../enums/ActionTypes"

export const fetchResources = () => ({
  type: ActionTypes.BASEDATA_RESOURCES_LIST_REQUEST,
})
